import { render } from "./Forums.vue?vue&type=template&id=951ee7f4&scoped=true"
import script from "./Forums.vue?vue&type=script&lang=js"
export * from "./Forums.vue?vue&type=script&lang=js"

import "./Forums.vue?vue&type=style&index=0&id=951ee7f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-951ee7f4"]])

export default __exports__